import { Component, OnInit } from '@angular/core';
import { Routes,Router,RouterModule}  from '@angular/router';
import { CommonService } from '../../services/common.service';
import { AppSettings } from '../../appSettings'; 
import { LoginService } from '../../services/login.service';

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-aicenter',
  templateUrl: './aicenter.component.html',
  styleUrls: ['./aicenter.component.css']
})
export class AicenterComponent implements OnInit {

  model:any={};
ex_ce_status: any;

packagelist:Array<Object>;
userwebsiteurl:string=AppSettings.userweburl;
getpackageinfodetApiUrl:string = AppSettings.getPackageInfo; 
checkIswebsite:Boolean=false;
checkUserRestApiUrl:string = AppSettings.checkuserdetail; 
checkpackageisactivated:string = AppSettings.packageisactivated; 
checkUserCreditRestApiUrl:string = AppSettings.checkusercredit;
checkUserCreditbyTypeRestApiUrl:string = AppSettings.checkusercreditbytype;
getpackagelistRestApiUrl:string = AppSettings.getPackageDetail; 
inserttrasnfeprocessRestApiUrl:string = AppSettings.inserttransferprocess;
getpackagevsuserApiUrl:string = AppSettings.getPackageNotbuy;
insertpackagevsuserApiUrl:string = AppSettings.insertpackagevsuser;
packageActivateApiUrl:string = AppSettings.PACKAGE_ACTIVATE;
CheckwebsiteExistsRestApiUrl:string = AppSettings.checkwebsitedetail; 
FetchMeSettingApiUrl: string = AppSettings.getmesettings;
convertmeApiUrl: string = AppSettings.convertme;
salemyinternetlifeApiUrl: string = AppSettings.salemyinternetlife;
getinternetlifesaledetailsApiUrl: string = AppSettings.getinternetlifesaledetails;

  constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router) { }

  ngOnInit() {
    this.loginService.localStorageData();
    this.loginService.viewsActivate();
    let user_id = localStorage.getItem('currentUserID');
    this.model.usergroup=localStorage.getItem('currentUsergroup');

    this.CommonService.editdata(this.getpackageinfodetApiUrl,user_id)
          .subscribe(resultdata =>{   
            this.packagelist=resultdata.result; 
            console.log("packageinfo-->",resultdata);
            this.ex_ce_status=resultdata.result[0]['ex_ce_status'];
            this.model.tot_amt=resultdata.result[0]['tamount']; 
            this.model.tamount_renewal=resultdata.result[0]['tamount_renewal']; //ME Money
            this.model.instructor_amount=resultdata.result[0]['instructor_amount'];
            this.model.instructor_amount_renewal=resultdata.result[0]['instructor_amount_renewal'];
            this.model.e_amt=resultdata.result[0]['eamount'];
            this.model.eamount_renewal=resultdata.result[0]['eamount_renewal']; 
            this.model.pw_amount=resultdata.result[0]['pw_amount'];
            this.model.pw_amount_renewal=resultdata.result[0]['pw_amount_renewal'];
            this.model.bw_amount=resultdata.result[0]['bw_amount'];
            this.model.bw_amount_renewal=resultdata.result[0]['bw_amount_renewal'];
            this.model.mall_amount=resultdata.result[0]['mall_amount'];
            this.model.mall_amount_renewal=resultdata.result[0]['mall_amount_renewal'];
            this.model.floor_amount=resultdata.result[0]['floor_amount'];
            this.model.floor_amount_renewal=resultdata.result[0]['floor_amount_renewal'];
            this.model.shop_amount=resultdata.result[0]['shop_amount'];
            this.model.shop_amount_renewal=resultdata.result[0]['shop_amount_renewal'];
            this.model.me_ai_amount=resultdata.result[0]['me_ai_amount'];
            this.model.dollar_amount=resultdata.result[0]['dollar_amount']; 
            this.model.growME=resultdata.result[0]['growME']; 
            this.model.ai_dollar=resultdata.result[0]['ai_dollar'];          
           
            if(resultdata.result[0]['ex_ce_status'] ==1 || resultdata.result[0]['ex_ce_status'] ==3|| resultdata.result[0]['ex_ce_status'] ==0){
                // redirect to mebankdashboard
                this.router.navigate(['/mebankdashboard']);
            }

            });


   

    // Initialize any data if needed
    this.initializeData();
  }

  initializeData() {
    // Any initialization logic for AI Center
    console.log('AI Center Component Initialized');
  }

}